<section class="cards-container">
  @if (isLoading) {
    <section class="cards-grid skeleton-grid" [style.grid-template-columns]="gridTemplateColumns">
      @for (card of visibleCards; track card.title) {
        <article class="card card--skeleton">
          <app-loading-skeleton [count]="1" width="60%" height="14px" borderRadius="6px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="40%" height="28px" borderRadius="6px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="80%" height="10px" borderRadius="6px"></app-loading-skeleton>
        </article>
      }
    </section>
  } @else {
  <section class="cards-grid" [style.grid-template-columns]="gridTemplateColumns">
    @for (card of visibleCards; track card.title; let idx = $index) {
      <article class="card" [ngClass]="getCardClass(idx)">
        @if (format === 'dealerPerformanceCard') {
          @if (getCardIcon(idx)) {
            <span class="dealer-card-icon" aria-hidden="true"><i [class]="getCardIcon(idx)"></i></span>
          }
          @if ((schema[idx].valueType) === 'amount') {
            <p>{{ (card.value ?? 0) | number:'1.0-0' }}</p>
          } @else {
            <p>{{ card.value || 0 }}</p>
          }
          <h4>{{ card.title }}</h4>
        } @else {
          <h4>{{ card.title }}</h4>
          <div class="card-header-row">
            @if ((schema[idx].valueType) === 'amount') {
              <p>{{ (card.value ?? 0) | number:'1.0-0' }}</p>
            } @else {
              <p>{{ card.value || 0 }}</p>
            }
            @if (showIcons && getCardIcon(idx)) {
              <span class="card-icon" [ngClass]="'card-icon-' + (idx % 4)" aria-hidden="true"><i [class]="getCardIcon(idx)"></i></span>
            }
          </div>
          <small>{{ card.subtitle ? (card.subtitle | camelCase) : '\u00A0' }}</small>
        }
      </article>
    }
  </section>
}

</section>
